
import React from 'react';
import { TaskLog } from '../TaskLog';
import { TemplateManagementDialog } from './TemplateManagementDialog';
import { EmailLogsDialog } from './EmailLogsDialog';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { AddTaskForm } from '@/components/AddTaskForm';
import { ScrollArea } from '@/components/ui/scroll-area';
import { UserManagementDialog } from '@/components/UserManagement/UserManagementDialog';
import { ClearDatabaseDialog } from './ClearDatabaseDialog';

interface DialogManagerProps {
  taskLogOpen: boolean;
  onTaskLogOpenChange: (open: boolean) => void;
  templateDialogOpen: boolean;
  onTemplateDialogOpenChange: (open: boolean) => void;
  emailLogsOpen: boolean;
  onEmailLogsOpenChange: (open: boolean) => void;
  newTaskDialogOpen: boolean;
  onNewTaskDialogOpenChange: (open: boolean) => void;
  userManagementOpen: boolean;
  onUserManagementOpenChange: (open: boolean) => void;
  isClearDialogOpen: boolean;
  onClearDialogOpenChange: (open: boolean) => void;
  onAddTask: (data: any) => void;
  onClearDatabase: () => void;
}

export const DialogManager = ({
  taskLogOpen,
  onTaskLogOpenChange,
  templateDialogOpen,
  onTemplateDialogOpenChange,
  emailLogsOpen,
  onEmailLogsOpenChange,
  newTaskDialogOpen,
  onNewTaskDialogOpenChange,
  userManagementOpen,
  onUserManagementOpenChange,
  isClearDialogOpen,
  onClearDialogOpenChange,
  onAddTask,
  onClearDatabase,
}: DialogManagerProps) => {
  return (
    <>
      <TaskLog 
        open={taskLogOpen} 
        onOpenChange={onTaskLogOpenChange} 
      />
      <TemplateManagementDialog
        open={templateDialogOpen}
        onOpenChange={onTemplateDialogOpenChange}
      />
      <EmailLogsDialog
        open={emailLogsOpen}
        onOpenChange={onEmailLogsOpenChange}
      />
      <UserManagementDialog
        open={userManagementOpen}
        onOpenChange={onUserManagementOpenChange}
      />
      <ClearDatabaseDialog
        open={isClearDialogOpen}
        onOpenChange={onClearDialogOpenChange}
        onConfirm={onClearDatabase}
      />
      <Dialog open={newTaskDialogOpen} onOpenChange={onNewTaskDialogOpenChange}>
        <DialogContent className="sm:max-w-[600px] max-h-[80vh] p-0 bg-[#1A1F2C] border-[#403E43] text-white">
          <ScrollArea className="h-full max-h-[80vh]">
            <div className="p-6">
              <AddTaskForm onSubmit={onAddTask} />
            </div>
          </ScrollArea>
        </DialogContent>
      </Dialog>
    </>
  );
};
